module.exports = __webpack_public_path__ + "static/media/br.a31e2576.svg";